<template lang="pug">
  .split-image-compare
    .a-box-xs-1x1
      .a-box-content
        .left-image-wrap.absolute-wrap(v-if="leftImage && leftImage.url")
          img.full-width(:src="leftImage.url" :alt="leftImage.alt_text")
          p.original.upper.semi-bold.color-slate(v-show="rightImage.url") Original
        .right-image-wrap(v-if="rightImage && rightImage.url")
          img(:src="rightImage.url" :alt="rightImage.alt_text")

</template>

<script>
  export default {
    props: {
      leftImage: {
        type: Object,
        default: () => ({})
      },
      rightImage: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="stylus">
  .split-image-compare
    .left-image-wrap
    .right-image-wrap
      position absolute
      top 0
      bottom 0
      overflow hidden
      background-color color-fog-light
      
      img
        position absolute
        top 0
        bottom 0
        height 100%
      
    .left-image-wrap
      left 0
      right 0
      
      img
        left 0
        
      .original
        position absolute
        bottom 1em
        left 1em
        background-color rgba(color-white, 0.8)
        border-radius 0.5em
        padding 0.25em 0.55em
      
    .right-image-wrap
      left 50%
      right 0
      border-left 2px solid color-white
      
      img
        right 0
      
</style>
